import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFlip, Pagination, Navigation } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/effect-flip';
import "./swiper.css";
const SwifeItem = ({ page1, page2 ,enabled=true}) => {
    const swiperRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const handleSlideClick = (e) => {
        if (swiperRef.current&&enabled) {
            const swiperInstance = swiperRef.current.swiper;
            setCurrentIndex(prev => {
                const _prev = (prev + 1) % 2;
                swiperInstance.slideTo(_prev);
                return _prev;
            });
        }
    };
    return (
        <Swiper
            effect={"flip"}
            grabCursor={true}
            pagination={false}
            navigation={false}
            allowTouchMove={false}
            modules={[EffectFlip, Pagination, Navigation]}
            className="mySwiper"
            ref={swiperRef}
            onSlideChange={() => {
                // 更新当前索引
                if (swiperRef.current) {
                    setCurrentIndex(swiperRef.current.swiper.activeIndex);
                }
            }}
        >
            <SwiperSlide onClick={handleSlideClick}>
                {page1}
            </SwiperSlide>
            <SwiperSlide onClick={handleSlideClick}>
                {page2}
            </SwiperSlide>
        </Swiper>
    );
}

export default SwifeItem;